var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"payment-terms"}},[_c('div',{staticClass:"content"},[_c('h2',{staticClass:"page-title"},[_vm._v("Information on Fees, Online Admissions & Payment Terms")]),_c('About',{attrs:{"message":_vm.terms}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }